import { useTranslation } from 'react-i18next';
import { capitalize } from 'lodash-es';
import { Text, tokens, Button } from '@hotjar/hotsauce';
import type { CMS } from '../IntegrationGuides';
import { IntegrationsIcon } from '../IntegrationGuides';
import { HeroWrapper, HeroCopyWrapper } from './styles';

interface CMSInstallationHeroProps {
  cms: CMS;
  onCMSClick: (cms: CMS) => void;
  onOtherPlatformsClick: () => void;
}

export const CMSInstallationHero = ({
  cms,
  onOtherPlatformsClick,
  onCMSClick,
}: CMSInstallationHeroProps): JSX.Element => {
  const { t } = useTranslation();
  const handleOnClick = () => {
    onCMSClick(cms);
  };

  return (
    <HeroWrapper data-testid="hero-section">
      <div>
        <IntegrationsIcon icon={cms} />
      </div>
      <HeroCopyWrapper>
        <Text
          css={{ marginBottom: tokens.spacer.x1 }}
          textType="header4"
          textColor="text_default"
          as="h2"
        >
          {t('activation:setup-wizard.main-page.hero.title-cms', { cms: capitalize(cms) })}
        </Text>
        <Text
          css={{ marginBottom: tokens.spacer.x2 }}
          textType="body2"
          textColor="text_default"
          as="p"
        >
          {t('activation:setup-wizard.main-page.hero.description-cms', {
            cms: capitalize(cms),
          })}
        </Text>
        <div>
          <Button css={{ marginRight: tokens.spacer.x2 }} onClick={handleOnClick} size="l">
            {t('activation:setup-wizard.main-page.hero.start-cms', { cms: capitalize(cms) })}
          </Button>
          <Button kind="secondary" onClick={onOtherPlatformsClick} size="l">
            {t('activation:setup-wizard.main-page.hero.use-other')}
          </Button>
        </div>
      </HeroCopyWrapper>
    </HeroWrapper>
  );
};
